import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import { useLazyProfileQuery } from "../../../redux/api/user/userAPI";
import { selectAuth } from "../../../redux/features/auth/auth-slice";
import { selectProfile } from "../../../redux/features/user/user-slice";
import { getConsumerPrivateRoutes } from "../../../screens/routes";
import { AppRoute } from "../../oversight-core/interfaces/app-routes";
import { IHttpError } from "../../oversight-core/interfaces/http-errror";
import SpinnerModal from "../../oversight-core/ui-elements/spinner/spinner";
import isMobileNumberVerified from "../../oversight-core/utils/isMobileNumberVerified";

const PublicRoute = () => {
  const navigate = useNavigate();
  const auth = useSelector(selectAuth);
  const profile = useSelector(selectProfile);
  const [getProfile, { isFetching, isLoading }] = useLazyProfileQuery();

  useEffect(() => {
    if (auth.token && !profile) {
      getProfile()
        .unwrap()
        .catch((error: IHttpError) => {
          if (isMobileNumberVerified(error)) {
            navigate(AppRoute.VERIFY_MOBILE_NUMBER);
          }
        });
      return;
    }

    if (auth.token && profile) {
      const route = getConsumerPrivateRoutes(auth.privileges, profile.role)
        .filter((route) => route.root)[0]
        ?.subRoutes?.find((route) => route.index);

      if (route) {
        navigate(route.path);
      }
    }
  }, [auth.token, profile]);

  return (
    <div className="bg-white">
      {!isFetching && !isLoading && <Outlet />}
      <SpinnerModal show={isLoading || isFetching} />
    </div>
  );
};

export default PublicRoute;
